import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import { IDialogState, DialogState } from '../../services/dialog-state.service';

/*

Component which can be use for creating a confirmation dialogs with details.
The component need to receive formatted data like array of strings.
The position of each string into array need to corispondent with the position of label into
array of items which Siteecore JSS return for this specific popup.

If Sitecore return array like:
['Amount', 'From account', 'To account', 'Description', 'Transfer Date']

we need to pass array to component like:
['1,234.00 USD', '0851780490', '22220003', 'transfer description', '25.05.2019']

if we pass array like:
['1,234.00 USD', '0851780490', null, 'transfer description', null]

the component will prevent showing of labels: 'To account' and 'Transfer Date'

*/

@Component({
  selector: 'ab-details-confirm-popup',
  templateUrl: './details-confirm-popup.component.html',
  styleUrls: ['./details-confirm-popup.component.scss']
})
export class DetailsConfirmPopupComponent {
  public errorState: boolean;
  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    public dialogRef: MatLegacyDialogRef<DetailsConfirmPopupComponent>
  ) {
    this.errorState =
      data !== undefined &&
      data.payment !== undefined &&
      data.payment.errorMessage !== undefined;
  }
  confirm() {
    this.dialogRef.close(true);
  }
  dismiss() {
    this.dialogRef.close(<IDialogState>{
      dialogState: DialogState.Dismiss
    });
  }
}
